import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCta } from '../SectionCta';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonials" className="bg-paper px-4 py-16 sm:py-24" data-id="element-303" data-mp="3mfhhs90jy3ju">
      <div className="mx-auto max-w-6xl" data-id="element-304" data-mp="3r93jx793ap1e">
        <div id="testimonials" data-id="element-305" data-mp="17ts10jaxjl">
          <SectionHeading kicker="Reader feedback" title="What readers think about the educational collection" subtitle="How readers use the volumes, reference tables, and practice exercises in their study routines." data-id="element-306" data-mp="668x2c0ikz" />
        </div>

        <ul className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-307" data-mp="e1ilt7dkyi6c">
          {testimonials.map((t, i) => {
          const featured = i === 0;
          return <li key={t.name} className={`flex flex-col rounded-3xl p-6 sm:p-7 ${featured ? 'bg-navy-900 text-white md:col-span-2' : 'bg-white text-ink ring-1 ring-ink/10'}`} data-id="element-308" data-mp="2avlofg728jx5" data-mpi={i}>
                <div className="flex items-center justify-between" data-id="element-309" data-mp="1ns9hb4zwkfmw">
                  <QuoteIcon className={`h-8 w-8 ${featured ? 'text-cta' : 'text-aqua'}`} aria-hidden="true" data-id="element-310" data-mp="1ity7gu9ly54o" />
                  <div className="flex gap-0.5" aria-label="5 out of 5" data-id="element-311" data-mp="1eu5w69stxkvm">
                    {Array.from({
                  length: 5
                }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-cta text-cta" aria-hidden="true" data-id="element-312" data-mp="2bhau14frqcxz" data-mpi={s} />)}
                  </div>
                </div>
                <blockquote className={`mt-4 leading-relaxed ${featured ? 'text-xl font-semibold sm:text-2xl' : 'text-[17px] text-ink/85'}`} data-id="element-313" data-mp="22hnoq7jx4mzn">
                  “{t.quote}”
                </blockquote>
                <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-314" data-mp="r1h0g555ajk2">
                  <img src={t.photo} alt={t.name} loading="lazy" className={`shrink-0 rounded-full object-cover ring-2 ${featured ? 'h-16 w-16 ring-cta' : 'h-14 w-14 ring-aqua'}`} data-id="element-315" data-mp="m3nrj4cgjbg3" />
                  <div data-id="element-316" data-mp="elpqzpc97ap0">
                    <p className="font-bold" data-id="element-317" data-mp="ekejpfjlnkt5">{t.name}</p>
                    <p className={`text-sm ${featured ? 'text-white/65' : 'text-ink/60'}`} data-id="element-318" data-mp="im04dn2dl3dw">
                      {t.role} · {t.country}
                    </p>
                  </div>
                </div>
              </li>;
        })}
        </ul>

        <SectionCta label="I want to explore the ABG Clinical Roadmap™" data-id="element-319" data-mp="9nxyou7p5mka" />
      </div>
    </section>;
}